<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected1 == '毛利润分析' ? 'selected1' : ''"
        @click="toggle1('毛利润分析')"
        >毛利润分析</span
      >
      <span>|</span>
      <span
        :class="selected1 == '毛利润明细' ? 'selected1' : ''"
        @click="toggle1('毛利润明细')"
        >毛利润明细</span
      >
    </div>

    <div v-show="selected1 == '毛利润分析'">
      <!-- <search-bar
        @search="searchProfitMonth"
        name="pi_inoutno,pi_custname,pi_remark"
        placeholder="输入单据编号、客户、备注进行查找"
        ref="searchBar"
      /> -->

      <year-filter-bar @change="onYearChange" ref="yearFilterBar" />

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
      </div>

      <div class="list-box">
        <div class="list-box-nav">
          <span
            :class="selected2 == '全部' ? 'selected2' : ''"
            @click="toggle2('全部', 'detail')"
            >全部</span
          >
          <div
            :class="selected2 == '业务员' ? 'selected2' : ''"
            @click="toggle2('业务员', 'seller')"
          >
            业务员
          </div>
          <span
            :class="selected2 == '客户' ? 'selected2' : ''"
            @click="toggle2('客户', 'cust')"
            >客户</span
          >
          <span
            :class="selected2 == '客户类型' ? 'selected2' : ''"
            @click="toggle2('客户类型', 'custtype')"
            >客户类型</span
          >
          <span
            :class="selected2 == '部门' ? 'selected2' : ''"
            @click="toggle2('部门', 'dept')"
            >部门</span
          >
          <span
            :class="selected2 == '物料' ? 'selected2' : ''"
            @click="toggle2('物料', 'prod')"
            >物料</span
          >
          <span
            :class="selected2 == '厂家品牌' ? 'selected2' : ''"
            @click="toggle2('厂家品牌', 'brand')"
            >厂家品牌</span
          >
        </div>
        <div class="weui-cells">
          <div
            class="weui-cell weui-cell_access"
            v-for="(item, index) in list1"
            :key="index"
            @click="onChangeChart(item)"
          >
            <div class="weui-cell__bd">
              <p v-if="querytype == 'detail'">{{ item.amountkind }}</p>
              <p v-if="querytype == 'brand'">{{ item.pr_brand }}</p>
              <p v-if="querytype == 'seller'">{{ item.sa_seller }}</p>
              <p v-if="querytype == 'cust'">{{ item.sa_custname }}</p>
              <p v-if="querytype == 'custtype'">{{ item.cu_type }}</p>
              <p v-if="querytype == 'prod'">{{ item.pr_detail }}</p>
              <p v-if="querytype == 'prod'">{{ item.pr_code }}</p>
              <p v-if="querytype == 'dept'">{{ item.dp_name }}</p>
            </div>
            <div class="weui-cell__ft">
              <p>{{ item.profit }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="selected1 == '毛利润明细'">
      <search-bar
        @search="searchSaleProfit"
        name="sa_custname,pr_detail"
        placeholder="输入客户、物料进行查找"
        ref="searchBar"
      />
      <filter-bar
        @change="searchSaleProfit"
        :filters="filters"
        ref="filterBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list2"
          :key="index"
          :to="{ name: 'SaleProfitReportDetail', params: { item } }"
        >
          <div class="weui-cell__bd">
            <p>{{ item.sa_custname }}</p>
            <p class="list-item-muted">{{ item.pd_inoutno }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.pr_detail }}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">
              {{ item.pi_date }}
            </p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ list2.length }}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import YearFilterBar from "@/components/YearFilterBar.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
    FilterBar,
    YearFilterBar,
  },
  data() {
    let year = new Date().getFullYear();

    return {
      defaultChartData: [
        { genre: "Sports", sold: 275 },
        { genre: "Strategy", sold: 115 },
        { genre: "Action", sold: 120 },
        { genre: "Shooter", sold: 350 },
        { genre: "Other", sold: 150 },
      ],
      result: {},
      list1: [], // 毛利润分析底部列表的数据
      list2: [], // 毛利润明细列表
      year,
      querytype: "detail",
      selected1: "毛利润分析",
      selected2: "全部",
      filters: [
        {
          type: "date",
          // name: ""
        },
      ],
      chart: null,
    };
  },
  mounted() {
    this.searchProfitMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchProfitMonth() {
      let me = this;

      me.$ajax({
        url: "/api/sale/report/saleProfitMonth",
        params: {
          year: me.year,
          querytype: me.querytype,
        },
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
          me.list1 = me.result.details;
        }
      });
    },
    searchSaleProfit(keyword) {
      let me = this;

      let filterBar = me.$refs.filterBar;
      let dateFilter = me.$refs.filterBar.parsedFilters[0];
      let period = dateFilter.fn(dateFilter.value, dateFilter, filterBar).value;

      let params = {
        number: 1,
        size: 99999,
        mode: "DETAIL",
        condition: [
          {
            type: "date",
            field: "pi_date",
            operation: "between",
            value: period,
          },
          // {type:"condition",value:" pi_class in ( 'SALEOUT','SALERETURN') and PI_STATUS='已审核'"}
        ],
        calculateFields: JSON.stringify([
          { field: "pd_taxamount", operation: "sum" },
          { field: "pd_nettotal", operation: "sum" },
          { field: "pd_ordertotal_std", operation: "sum" },
          { field: "pd_total", operation: "sum" },
          { field: "pd_feetotal", operation: "sum" },
          { field: "pd_tzamount", operation: "sum" },
          { field: "pd_profit", operation: "sum" },
          { field: "pd_profitpresent", operation: "average" },
        ]),
        page: 1,
        start: 0,
        limit: 99999,
        // filter: [{"type":"string","operation":"c","operationText":"包含","label":"部门","field":"department.dp_name","value":"总"}]
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value:
            "(customer.cu_name like '%" +
            keyword +
            "%' or pr_detail like '%" +
            keyword +
            "%')",
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/sale/report/saleProfit",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list.list;
          // me.initChart()
          // me.initList1()
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });

      // data.forEach((item) => {
      //   if(item.amount) {
      //     this.chart.guide().text({
      //       position: [ item.period, item.amount ],
      //       content: item.amount,
      //       style: {
      //         fill: '#808080',
      //         textAlign: 'center'
      //       },
      //       offsetY: item.amount >= 0 ? -15 : 15
      //     })
      //   }
      // })
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    onChangeChart(item) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: item.text, value: 0 },
        { index: 12, type: item.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: item.text,
          value: item["profit" + (i + 1)] || 0,
        });
      }
      this.initChart(arr);
    },
    toggle1(val) {
      this.selected1 = val;

      if (val == "毛利润明细") {
        this.searchSaleProfit();
      }
    },
    toggle2(val, querytype) {
      this.selected2 = val;
      this.querytype = querytype;
      this.searchProfitMonth();
    },
    onYearChange(year) {
      this.year = year;
      this.searchProfitMonth();
    },
    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];
      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push({
          text: item.text,
          type: "金额",
          index: i,
          value: Number(item.amount.toFixed(2)),
        });
      });

      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push({
            index: i,
            text: textArr[i],
            type: "金额",
            value: 0,
          });
        }
      }

      return arr;
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559f;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-box-nav {
  width: 100%;
  padding: 10px 10px 0;
  box-sizing: border-box;
  font-size: 13px;
  color: var(--weui-FG);
  display: flex;
  justify-content: space-around;
}
.selected2 {
  font-weight: 600;
  border-bottom: 2px solid var(--weui-FG);
}
.list-box-content {
  overflow-y: scroll;
}

.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
  .filter-bar {
    padding: 6px 0 2px 0;
  }
}
</style>